import { useState, useEffect } from 'react';
import apiFetch from "./../apiClient";

interface Expense {
  id: string;
  amount: number;
  category: string;
  date: string;
  parcelas: number;
  description: string;
  paymentMethod: string;
}

const PAYMENT_METHODS = ['Dinheiro', 'Débito', 'Crédito', 'PIX', 'Transferência'];

export function AddExpenseCard({categories, defaultMonth, defaultYear, editingExpense, onSaved, onCancel}) {
    const defaultDate = `${defaultYear}-${String((defaultMonth ?? new Date().getMonth()) + 1).padStart(2,'0')}-01`;
    const [expenseForm, setExpenseForm] = useState({ amount:'', category:'', date: defaultDate, parcelas: 1, description:'', paymentMethod:'' });
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        if (editingExpense) {
            setExpenseForm({
                amount: editingExpense.transacao_valor,
                category: editingExpense.categoria_id,
                date: (editingExpense.transacao_data || '').slice(0, 10),
                parcelas: 1,
                description: editingExpense.transacao_descricao || '',
                paymentMethod: editingExpense.transacao_forma_de_pagamento || ''
            });
        }
    }, [editingExpense]);

    const addExpenses = async () => {
        const createExpense: Expense = {
            id: Date.now().toString(),
            amount: parseFloat(expenseForm.amount),
            category: expenseForm.category,
            date: expenseForm.date,
            parcelas: expenseForm.parcelas,
            description: expenseForm.description || null,
            payment_method: expenseForm.paymentMethod || null
        };
        setIsProcessing(true);
        setError(null);
        try {
            if (editingExpense) {
                await apiFetch(`/api/financecontrol/update-expense/${editingExpense.transacao_id}`, {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(createExpense),
                });
            } else {
                await apiFetch("/api/financecontrol/create-expense", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(createExpense),
                });
            }
            resetExpenseForm();
            await onSaved?.();
        } catch (err) {
            setError(err.message);
        } finally {
            setIsProcessing(false);
        }
    };

    const resetExpenseForm = () => {
        setExpenseForm({
            amount: "",
            category: "",
            date: "",
            parcelas: 1,
            description: "",
            paymentMethod: ""
        });
    };
    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <label htmlFor="expense-category" className="form-label text-muted-custom small">Categoria</label>
                <select
                    id="expense-category"
                    className="form-select form-select-custom"
                    value={expenseForm ? expenseForm.category : ''}
                    onChange={(e) => setExpenseForm({ ...expenseForm, category: e.target.value})}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                >
                    <option value="" disabled>Categoria</option>
                    {categories && categories.filter(cat => cat.categoria_tipo === 'debito').map((category) => (
                        <option key={category.categoria_id} value={category.categoria_id}>{category.categoria_nome}</option>
                    ))}
                </select>
                {/* <input
                    type="text"
                    className="form-control"
                    placeholder="e.g., Employment, Investment"
                    value={expenseForm != null ? expenseForm.category : ''}
                    onChange={(e) => setExpenseForm({ ...expenseForm, category: e.target.value })}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                /> */}
            </div>
            <div className="col-12 col-md-6">
                <label className="form-label text-muted-custom small">Parcelas</label>
                <input
                    type="number"
                    step="1"
                    min="1"
                    className="form-control"
                    placeholder="1"
                    value={expenseForm != null ? expenseForm.parcelas : ''}
                    onChange={(e) => setExpenseForm({ ...expenseForm, parcelas: e.target.value })}
                    disabled={!!editingExpense}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        borderLeft: 'none',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0 0.5rem 0.5rem 0'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                />
                {editingExpense && (
                    <small className="text-muted-custom d-block mt-1">Parcelas só se aplica ao criar um gasto novo</small>
                )}
            </div>
            <div className="col-12 col-md-4">
                <label className="form-label text-muted-custom small">Valor</label>
                <div className="input-group">
                    <span 
                        className="input-group-text" 
                        style={{
                            backgroundColor: 'var(--color-surface)',
                            border: '1px solid var(--color-border)',
                            borderRight: 'none',
                            color: 'var(--color-text-secondary)'
                        }}
                    >
                        R$
                    </span>
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="0.00"
                        value={expenseForm != null ? expenseForm.amount : ''}
                        onChange={(e) => setExpenseForm({ ...expenseForm, amount: e.target.value })}
                        style={{
                            backgroundColor: 'var(--color-surface)',
                            border: '1px solid var(--color-border)',
                            borderLeft: 'none',
                            color: 'var(--color-text-primary)',
                            padding: '0.75rem 1rem',
                            borderRadius: '0 0.5rem 0.5rem 0'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                    />
                </div>
            </div>
            <div className="col-12 col-md-4">
                <label className="form-label text-muted-custom small">Data da Compra</label>
                <input
                    type="date"
                    className="form-control"
                    value={expenseForm != null ? expenseForm.date : ''}
                    onChange={(e) => setExpenseForm({ ...expenseForm, date: e.target.value })}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                />
            </div>
            <div className="col-12 col-md-6">
                <label htmlFor="expense-description" className="form-label text-muted-custom small">Descrição (opcional)</label>
                <input
                    id="expense-description"
                    type="text"
                    className="form-control"
                    placeholder="Ex: Compra do mês"
                    value={expenseForm != null ? expenseForm.description : ''}
                    onChange={(e) => setExpenseForm({ ...expenseForm, description: e.target.value })}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                />
            </div>
            <div className="col-12 col-md-6">
                <label htmlFor="expense-payment-method" className="form-label text-muted-custom small">Forma de pagamento (opcional)</label>
                <select
                    id="expense-payment-method"
                    className="form-select form-select-custom"
                    value={expenseForm != null ? expenseForm.paymentMethod : ''}
                    onChange={(e) => setExpenseForm({ ...expenseForm, paymentMethod: e.target.value })}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                >
                    <option value="">Não informado</option>
                    {PAYMENT_METHODS.map((method) => (
                        <option key={method} value={method}>{method}</option>
                    ))}
                </select>
            </div>
            <div className="col-12">
                <div className="d-flex gap-2 justify-content-end">
                    <button
                        className="btn btn-outline-custom"
                        onClick={() => {
                            resetExpenseForm();
                            onCancel?.();
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        className="btn btn-primary-custom"
                        onClick={addExpenses}
                        disabled={isProcessing}
                    >
                        {editingExpense ? 'Atualizar' : 'Adicionar'} Gasto
                    </button>
                </div>
                {error && (
                    <small className="text-danger-custom d-block mt-1 text-end">{error}</small>
                )}
            </div>
        </div>
    );
}